import { render } from "./layers.vue?vue&type=template&id=4137a658"
import script from "./layers.vue?vue&type=script&lang=js"
export * from "./layers.vue?vue&type=script&lang=js"

import "./layers.vue?vue&type=style&index=0&id=4137a658&lang=css"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__